export default __webpack_public_path__ + "static/media/14.91ca99c0.png";